import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Context from '#context'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateRight } from '@fortawesome/pro-regular-svg-icons'

import { Button } from 'flowbite-react'

/**
 * @class
 * @classdesc - Send Downlinks to API.
 * @example
 * <Downlinks
 * clickDownlink={clickDownlink}
 * reloadPage={this.reloadPage}
 * />
 */
export default class Downlinks extends Component {
	static contextType = Context

	/**
	 * @typedef {Object} PropTypes
	 * @property {Object} device - The device object.
	 * @property {Function} clickDownlink - Send downlink to API.
	 * @property {Function} reloadPage - Reload parent page.
	 */
	static propTypes = {
		device: PropTypes.object.isRequired,
		clickDownlink: PropTypes.func.isRequired,
		reloadPage: PropTypes.func.isRequired,
	}
	static defaultProps = {
		device: {},
		clickDownlink: () => {},
		reloadPage: () => {},
	}

	render() {
		const { t, instance } = this.context
		const { device, clickDownlink, reloadPage } = this.props

		const isIoMCF = instance.downlinks.ioMCF.includes(device.typeId)

		return (
			<div>
				<div className="mb-1">{t('devices.output')}:</div>
				<div className="flex space-x-2 mb-4">
					<Button
						className="w-1/2"
						color={isIoMCF ? "success" : "failure"}
						onClick={() => clickDownlink(false)}
					>
						{t('all.on')}
					</Button>
					<Button
						className="w-1/2"
						color={isIoMCF ? "failure" : "success"}
						onClick={() => clickDownlink(true)}
					>
						{t('all.off')}
					</Button>
					<Button onClick={reloadPage.bind(this)}>
						<FontAwesomeIcon size="xl" icon={faRotateRight} />
					</Button>
				</div>
			</div>
		)
	}
}
